import {
  Box,
  Grid,
  styled,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import DataKandidatPage from "./Components/DataKandidatPage";
import DataKeluargaKandidatPage from "./Components/DataKeluargaKandidatPage";
import DataPribadiKandidatPage from "./Components/DataPribadiKandidatPage";
import DataPendidikanKandidatPage from "./Components/DataPendididkanKandidatPage";
import DataTrainingKandidatPage from "./Components/DataTrainingKandidatPage";
import DataBahasaKandidatPage from "./Components/DataBahasaKandidatPage";
import DataKegiatanSosialKandidatPage from "./Components/DataKegiatanSosialKandidatPage";
import DataPekerjaanKandidatPage from "./Components/DataPekerjaanKandidatPage";
import DataJawabanKandidatPage from "./Components/DataJawabanKandidatPage";
import useFetchKandidatDetail from "../../api/effects/queries/Kandidat/useFetchKandidatDetail";
import DataKontakDaruratKandidatPage from "./Components/DataKontakDaruratPage";
import DataReferensiKandidatPage from "./Components/DataReferensiKandidatPage";

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "2.2em",
}));

export const SubTitleTypography = styled(Typography)(({ theme }) => ({
  paddingTop: "6%",
  fontWeight: "bold",
}));

export const IconTypography = styled(Typography)(({ theme }) => ({
  paddingTop: "4%",
}));

export const BaseGrid = styled(Grid)(({ theme }) => ({
  padding: "4%",
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "white",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "rgba(0,0,0,0.1)",
  },
}));

export const TableCellHeader = styled(TableCell)(({ theme }) => ({
  maxWidth: "90px",
  padding: "5px",
  fontSize: "1.2em",
  fontWeight: "bold",
  wordBreak: "break-word",
}));

export const TableCellWidth = styled(TableCell)(({ theme }) => ({
  maxWidth: "90px",
  padding: "5px",
  fontSize: "1.2em",
  wordBreak: "break-word",
}));

const PrintBox = styled(Box)(({ theme }) => ({
  [`@media print`]: {
    // maxHeight: "27cm",
    size: "A4",
    // height: "287mm",
    width: "210mm",
    margin: "0",
    color: "#000",
    backgroundColor: "#fff",
    fontSize: "0.6em",
    pageBreakInside: "avoid",
    "-webkit-print-color-adjust": "exact",
    // orientation: "landscape",
    //   "-webkit-transform": "rotate(-90deg)",
    //   "-moz-transform": "rotate(-90deg)",
    //   filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)",
  },
  maxWidth: "1280px",
}));

export default function KandidatViewPage() {
  const { KandidatID } = useParams();

  const { data: KandidatDetailData } = useFetchKandidatDetail(KandidatID!);

  return (
    <Grid container justifyContent="center">
      {KandidatDetailData !== undefined ? (
        <Box>
          <PrintBox>
            <DataPribadiKandidatPage
              data={KandidatDetailData.DATA_PRIBADI[0]}
              foto={KandidatDetailData.FOTO}
            />
          </PrintBox>
          <PrintBox>
            <DataKandidatPage data={KandidatDetailData.DATA_KANDIDAT[0]} />
          </PrintBox>
          <PrintBox>
            <DataKeluargaKandidatPage
              data={KandidatDetailData.DATA_KELUARGA_OT}
              title={"Data Susunan Keluarga (Dari Orangtua, Termasuk Diri Sendiri)"}
            />
          </PrintBox>
          <PrintBox>
            <DataKeluargaKandidatPage
              data={KandidatDetailData.DATA_KELUARGA}
              title={"Data Susunan Keluarga (Bagi yang Sudah Menikah)"}
            />
          </PrintBox>
          <PrintBox>
            <DataPendidikanKandidatPage
              data={KandidatDetailData.DATA_PENDIDIKAN}
            />
          </PrintBox>
          <PrintBox>
            <DataTrainingKandidatPage data={KandidatDetailData.DATA_TRAINING} />
          </PrintBox>
          <PrintBox>
            <DataBahasaKandidatPage data={KandidatDetailData.DATA_BAHASA} />
          </PrintBox>
          <PrintBox>
            <DataKegiatanSosialKandidatPage
              data={KandidatDetailData.DATA_SOSIAL}
            />
          </PrintBox>
          <PrintBox>
            <DataPekerjaanKandidatPage
              data={KandidatDetailData.DATA_PEKERJAAN}
            />
          </PrintBox>
          <PrintBox>
            <DataKontakDaruratKandidatPage data={KandidatDetailData.DATA_KONTAK_DARURAT}/>
          </PrintBox>
          <PrintBox>
            <DataReferensiKandidatPage data={KandidatDetailData.DATA_KONTAK_REFERENSI}/>
          </PrintBox>
          <PrintBox>
            <DataJawabanKandidatPage data={KandidatDetailData.DATA_JAWABAN} />
          </PrintBox>
        </Box>
      ) : (
        <span />
      )}
    </Grid>
  );
}
